// The contractor "shared" components (dashboard, types, subscription types,
// stats, calendar...) are reused as tabs on both the subscriptions page and
// the guarantees/warranties page. When rendered there, their data requests
// must be scoped so the backend returns the right flavor of content:
//   /contractors/subscriptions  ->  subscription=1
//   /contractors/warranties     ->  warranty=1
//
// Everywhere else (e.g. the regular /contractors page) this is inert, so the
// shared components keep behaving exactly as before. The page-specific lists we
// kept during the page merges (SubscriptionsList / GuaranteesList / their
// ServicingList) hit their own endpoints and must NOT use this.

const SCOPES = [
    { type: 'subscription', path: '/contractors/subscriptions', params: { subscription: 1 } },
    { type: 'warranty', path: '/contractors/warranties', params: { warranty: 1 } },
]

const activeScope = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return SCOPES.find(scope => window.location.pathname.startsWith(scope.path)) || null
}

// Spread into an axios request config to tag a shared request, e.g.
//   Api.get(url, contractorScopeConfig())
//   Api.get(url, { cancelToken, ...contractorScopeConfig() })
export const contractorScopeConfig = () => {
    const scope = activeScope()

    return scope ? { params: { ...scope.params } } : {}
}

// Which flavor the shared components are currently rendered as -
// 'subscription', 'warranty' or null when they are not scoped at all.
// Use it to pick scope specific labels, e.g.
//   contractorScopeType() === 'warranty' ? ... : ...
export const contractorScopeType = () => {
    const scope = activeScope()

    return scope ? scope.type : null
}
